/* Shopioso app delay, patched.

   What it does, unchanged: the content_for_header rewrite in
   layout/theme.liquid emits every app <script> with data-src instead of src
   (and every <link> with data-href), so nothing third-party loads with the
   page. This file turns them back on once the visitor is actually there.

   What was wrong with how it did it, on a phone:

   1. The eight activity listeners were registered non-passive on window --
      addEventListener(type, fn, false). For touchstart, touchmove and scroll
      that means the browser has to wait for the handler to return before it
      can scroll, and the handler was the entire flush. The first swipe paid
      for all of it.

   2. The flush set src on every deferred tag inside one synchronous loop, so
      ~15 third-party bundles -- Klaviyo, Gorgias, Judge.me, Instafeed,
      Clarity, free gifts, Bugsnag, the Snapchat pixel -- started
      downloading, parsing and executing together. On a mid-range phone that
      is a multi-second main-thread stall, and because every navigation is a
      fresh document it was paid again on every page, not once per session.

   3. The listeners were never removed, so all eight stayed bound for the life
      of the page even after their one job was done.

   The deferral is kept -- that is the point of the app -- but the release is
   made cheap: passive one-shot listeners, stylesheets let through together,
   scripts a few per frame so the main thread gets a gap between bundles.

   StartAsyncLoading and StartKernelLoading must still be dispatched once
   everything is enabled: the rewritten content_for_header listens for them and
   no app initialises if they stop firing. */

var script_loaded = false;

(function () {
  var ACTIVITY_EVENTS = [
    'mousedown', 'mousemove', 'keydown', 'scroll',
    'touchstart', 'click', 'keypress', 'touchmove'
  ];
  var LISTENER_OPTS = { passive: true };
  var FALLBACK_DELAY = 12000;
  var SCRIPTS_PER_FRAME = 3;
  var fallbackTimer = null;

  function collect(tagName, attr) {
    var found = [];
    var nodes = document.getElementsByTagName(tagName);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute(attr) !== null) found.push(nodes[i]);
    }
    return found;
  }

  /* rAF never fires in a background tab, which would leave the release half
     done if the visitor switches away mid-flush. */
  function nextFrame(fn) {
    if (document.hidden || typeof requestAnimationFrame !== 'function') {
      setTimeout(fn, 16);
    } else {
      requestAnimationFrame(fn);
    }
  }

  function signalReady() {
    setTimeout(function () {
      document.dispatchEvent(new CustomEvent('StartAsyncLoading'));
      document.dispatchEvent(new CustomEvent('StartKernelLoading'));
    }, 400);
  }

  /* Stylesheets go together: they are render-blocking for the widgets that
     need them and cost nothing to start. Scripts are spread across frames --
     the expensive part is each bundle's parse and execute, so staggering the
     starts spreads that cost instead of landing it all in one task. */
  function release() {
    var links = collect('link', 'data-href');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', links[i].getAttribute('data-href'));
      delete links[i].dataset.href;
    }

    var scripts = collect('script', 'data-src');
    var index = 0;

    (function step() {
      var budget = SCRIPTS_PER_FRAME;
      while (index < scripts.length && budget-- > 0) {
        var el = scripts[index++];
        el.setAttribute('src', el.getAttribute('data-src'));
        delete el.dataset.src;
      }
      if (index < scripts.length) {
        nextFrame(step);
        return;
      }
      signalReady();
    })();
  }

  function detachActivityListeners() {
    for (var i = 0; i < ACTIVITY_EVENTS.length; i++) {
      window.removeEventListener(ACTIVITY_EVENTS[i], loadJSscriptsNow, LISTENER_OPTS);
    }
  }

  window.loadJSscriptsNow = function () {
    if (script_loaded) return;
    script_loaded = true;
    detachActivityListeners();
    if (fallbackTimer) {
      clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }
    console.log('Shopioso scripts have loaded.');
    release();
  };

  window.loadJSscripts = function () {
    if (script_loaded || fallbackTimer) return;
    fallbackTimer = setTimeout(function () {
      fallbackTimer = null;
      if (script_loaded) return;
      console.log('Shopioso 12s wait');
      loadJSscriptsNow();
    }, FALLBACK_DELAY);
  };

  for (var i = 0; i < ACTIVITY_EVENTS.length; i++) {
    window.addEventListener(ACTIVITY_EVENTS[i], loadJSscriptsNow, LISTENER_OPTS);
  }

  document.addEventListener('DOMContentLoaded', loadJSscripts);
  window.addEventListener('load', loadJSscripts);
})();
